import React, { useEffect, useState } from "react";
import Sidebaar from "../Component/Sidebar";
import { Col } from "react-bootstrap";
import { Box, Checkbox } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { Base_Url } from "../BaseUrl";
import { redirect, useNavigate } from "react-router-dom";
import userimage from "../assets/images/user.png"
import TitleComp from "../Component/TitleComp";
import { Bars } from "react-loader-spinner";
import { ToastContainer, toast } from "react-toastify";

function User() {

  let token = localStorage.getItem("token")
  const navigate = useNavigate()
  const [search, setsearch] = useState("")
  const [loading, setloading] = useState(false)
  const [data, setdata] = useState([])

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const handleuser = () => {
    axios.get(`${Base_Url}/users?all=1`, { headers }).then((res) => {
      setdata(res.data.data)

      // console.log(res.data.data)
    })
  }



  useEffect(() => {
    if (search.length == 0) {
      handleuser()
    }
  }, [search])

  const columns = [

    {
      field: "image",
      headerName: "Image",
      flex: 1,
      renderCell: (params) => {
        return (
          <img src={`${Base_Url}/${params.row.image}`} onClick={(e) => handleRowClick(params)} style={{ height: "50px", width: "50px", objectFit: "contain", borderRadius: "50%" }} className="img-fluid" onError={(e) => {
            e.target.onerror = null; // prevent infinite loop in case the error image also fails to load
            e.target.src = `${userimage}`; // replace with your error image URL
          }} alt="" />
        )
      }
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      renderCell: (params) => {

        return (
          <p onClick={(e) => handleRowClick(params)}>{params.row.name}</p>
        )
      }
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      renderCell: (params) => {

        return (
          <p onClick={(e) => handleRowClick(params)}>{params.row.email}</p>
        )
      }
    },

    {
      field: "phone",
      headerName: "Phone",
      flex: 1,
      renderCell: (params) => {

        return (
          <p onClick={(e) => handleRowClick(params)}>{params.row.phone}</p>
        )
      }
    },

    {
      field: "delete",
      headerName: "Block User",
      flex: 1,
      renderCell: (params) => {
        return (
          <Checkbox
            onChange={(e) => handleBlockUser(e, params.row._id, params.row.deleted_at)} checked={params.row.deleted_at == null ? false : true} // Assuming userId is in params.row.id
          />
        )
      }
    },


  ]

  const handleBlockUser = (e, id, status) => {
    e.preventDefault()

    setloading(true)
    let requestdata = {
      _id: id,
      deleted_at: status == null ? "1" : null
    }
    axios.put(`${Base_Url}/users`, requestdata, { headers }).then((res) => {
      console.log(res.data)
      if (res.data.error == 0) {
        handleuser()
        setloading(false)
        toast.success(status == null ? "User Block Successfully" : "User Unblock Successfully")
      }
    }).finally(() => {
      setloading(false)
    })
  }

  const handleRowClick = (params) => {
    navigate(`/user/detail`, { state: params.row })
  }



  const getRowId = (row) => row._id;

  const handlefilter = (e) => {
    e.preventDefault();

    // Check if the search term is numeric
    const isNumeric = /^\d+$/.test(search);

    let res = data.filter((item) => {
      if (isNumeric) {
        // If the search term is numeric, do not convert to lowercase
        return item.name?.includes(search) ||
          item.phone?.includes(search) ||
          item.email?.includes(search);
      } else {
        // If the search term is a string, convert to lowercase
        const searchLower = search.toLowerCase();
        return item.name?.toLowerCase()?.includes(searchLower) ||
          item.phone?.toLowerCase()?.includes(searchLower) ||
          item.email?.toLowerCase()?.includes(searchLower);
      }
    });

    setdata(res);
  };






  return (
    <>
      <ToastContainer />
      {loading && (
        <div className="overlay">
          <Bars
            height="80"
            width="80"
            color="#051322"
            ariaLabel="bars-loading"
            visible={true}
          />
        </div>
      )}
      <Sidebaar
        content={
          <>
            <div className="col-md-12">
              <div className="mb-2">
                <TitleComp title="User List" />
              </div>

            </div>
            <div className="col-md-6">
              <form class="" onSubmit={(e) => handlefilter(e)}>
                <div class="input-group mt-4">
                  <input type="search" placeholder="Search By Name , Email , Mobile Number" value={search} onChange={(e) => setsearch(e.target.value)} class="form-control shadow-none" />
                  <button class="btn bg-primary text-white"><i class="fa-solid fa-magnifying-glass"></i></button>
                </div>
              </form>
            </div>
            <Col md="12">
              <Box sx={{ height: 500, width: "100%" }}>
                <DataGrid
                  //   rows={data} // Update this line
                  rows={data.map((row, index) => ({
                    ...row,
                    index,
                  }))}
                  columns={columns}

                  pageSize={5}
                  getRowId={getRowId}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 10 } },
                  }}
                  pageSizeOptions={[5, 10, 25]}
                />
              </Box>
            </Col>
          </>
        }
      />
    </>
  );
}

export default User;


